import { Component, input, output } from '@angular/core';
import type { InnogyComponentRendering } from '@core/jss-models';
import { CommonModule } from '@angular/common';
import {
  GenericLinkDirective,
  GenericRichTextDirective,
} from '@core/jss-utils';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';
import { NgbCollapse } from '@ng-bootstrap/ng-bootstrap';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { CrntIcon } from '@essent/current-web-angular';

import { OrderContent } from '../../order-fulfillment-container.model';

@Component({
  selector: 'wl-order-redirect-to-mijn',
  templateUrl: './order-redirect-to-mijn.component.html',
  styleUrls: [
    './order-redirect-to-mijn.component.essent.scss',
    './order-redirect-to-mijn.component.ed.scss',
  ],
  standalone: true,
  imports: [
    CommonModule,
    JssModule,
    GenericRichTextDirective,
    AutomationIdDirective,
    CSCaptureDirective,
    NgbCollapse,
    CrntIcon,
    GenericLinkDirective,
  ],
})
export class OrderRedirectToMijnComponent {
  readonly rendering = input<InnogyComponentRendering>();
  readonly content = input.required<OrderContent>();

  readonly continueAsNewCustomer = output();

  automationId = 'order-redirect-to-mijn';
}
